/**
 * Harvest Monitoring (Kemandoran) API Service
 * Handles API calls for the per-foreman-group monitoring report.
 */

import api from '../../../auth/apiClient';
import { getHarvestForemanEndpoint } from '../apiConfig';
import type { HarvestForemanResponse, HarvestMonitoringFilters } from '../types';

export class HarvestForemanApiService {
    /**
     * Fetch harvest monitoring data grouped by foreman group (kemandoran).
     */
    static async getMonitoringForeman(filters: HarvestMonitoringFilters): Promise<HarvestForemanResponse> {
        const endpoint = getHarvestForemanEndpoint('MONITORING_FOREMAN');

        // allowed_divisions is only used for legacy FE filtering; pass the rest.
        const { allowed_divisions, ...apiParams } = filters;

        const response = await api.get<HarvestForemanResponse>(endpoint, {
            params: apiParams,
        });
        return response.data;
    }
}
